module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hHoss"))).then(() => parcelRequire('1iHdE'));